import { IconButton, Menu, MenuItem } from '@mui/material';
import { Box } from '@mui/system';
import { GridMoreVertIcon } from '@mui/x-data-grid';
import React, { useState } from 'react'
import copy from 'copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { showSuccessNotification, showErrorNotification } from '../../../../../../redux/actions'

function EventOptionsMenu({
    row,
    onClickEditEvent,
    onClickArchiveEvent,
    onClickGovXIdLink
}) {

    const [menuAnchor, setMenuAnchor] = useState(null)
    const dispatch = useDispatch()

    const handleGovXIdLink = () => {
        const offer = {
            link: row.row.eventLink,
            id: row.row.id
        }
        onClickGovXIdLink(offer);
    };

    /**
     * Handles event ID copy action - uses copy-to-clipboard library with notifications
     */
    const handleGovXIdCopy = () => {
        const eventId = row.row.id;

        try {
            const success = copy(eventId);
            if (success) {
                dispatch(showSuccessNotification('Event ID copied to clipboard'));
            } else {
                dispatch(showErrorNotification('Failed to copy Event ID. Please try again.'));
            }
        } catch (err) {
            console.error('Copy failed:', err);
            dispatch(showErrorNotification('Failed to copy Event ID. Please try again.'));
        }
    };

    return (
        (<Box>
            <IconButton style={{ paddingTop: '9px' }} onClick={(e) => setMenuAnchor(e.currentTarget)}>
                <GridMoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={() => {
                    setMenuAnchor(null)
                }}
            >
                <MenuItem onClick={() => { onClickEditEvent(row.row.id); setMenuAnchor(null) }} data-gxid="editEventMenuLink">
                    Edit Event
                </MenuItem>
                <MenuItem onClick={() => { handleGovXIdLink(); setMenuAnchor(null); }} data-gxid="eventGovxLink">
                    Copy GOVX ID Link
                </MenuItem>

                {/* Copy event ID option - copies ID to clipboard with toast notification */}
                <MenuItem onClick={() => { handleGovXIdCopy(); setMenuAnchor(null); }} data-gxid="eventGovxCopy">
                    Copy Event ID
                </MenuItem>
                <MenuItem onClick={() => { onClickArchiveEvent([row.row.id]); setMenuAnchor(null) }} data-gxid="archiveEventLink">
                    Archive Event
                </MenuItem>
            </Menu>
        </Box>)
    )
}

export default EventOptionsMenu